import "./index.css"
import logo_hogcloud1 from "../../assets/images/hogcloud-logo1.svg";
import logo_hogcloud_forward from "../../assets/images/hogcloud_logo_forward.png";
import React, { useState } from 'react';
const product_model_christmas_tree = "/images/snapcharms/standard_model_christmas_tree1.webp";



const Home = () => {
    const [isAnimating, setIsAnimating] = useState(true);

    const restartAnimation = (e: any) => {
        // Temporarily remove and re-add the class to restart animation
        e.target.classList.remove('animate');
        void e.target.offsetWidth; // Trigger reflow
        e.target.classList.add('animate');
    };
    return <>
              <div className="banner">
                <img
                    src={logo_hogcloud1}
                    alt="Hogcloud Logo"
                    className={`logo ${isAnimating ? 'animate' : ''}`}
                    onClick={restartAnimation}
                />
                <h1 className="banner-text">Hogcloud</h1>
                <img
                    src={logo_hogcloud1}
                    alt="Hogcloud Logo"
                    className={`logo logo-flipped ${isAnimating ? 'animate' : ''}`}
                    onClick={restartAnimation}
                />
            </div>
            <div className="cards-container">
                <div className="card" onClick={() => {
                    window.location.href = "/shop";
                }}>
                    <h2 className="card-header">Products</h2>
                    <div className="card-content">
                        <p>Checkout out our store for unique, handcrafted products.</p>
                    </div>
                </div>
                <div className="card" onClick={() => {
                    window.location.href = "/services";
                }}>
                    <h2 className="card-header">Services</h2>
                    <div className="card-content">
                        <p>Professional services tailored to meet your business needs and objectives.</p>
                    </div>
                </div>
                <div className="card" onClick={() => {
                    window.open("https://learning.hogcloud.net", "_blank");
                }}>
                    <h2 className="card-header">Learning</h2>
                    <div className="card-content">
                        <p>Educational resources, tutoring, and training programs to help you grow and succeed.</p>
                    </div>
                </div>
            </div>
            
            <div className="shop-now-section">
                <div className="column-1" onClick={() => { window.location.href = "/shop"; }}>
                    <h2 className="shop-now-title">Shop Now</h2>
                </div>
                <div className="column-2" onClick={() => { window.location.href = "/shop"; }}>
                    <img 
                        src={product_model_christmas_tree} 
                        alt="Christmas Tree Model Product" 
                        className="shop-product-image"
                    />
                </div>
            </div>
    
    
    </>;
  
    };


export default Home;
